import {
  Checklist,
  Section,
  SupportingItemInput,
  RequestedSupportingItem,
} from '@taxfyle/api-internal/internal/info_gathering_pb'
import {
  ChecklistDTO,
  SectionDTO,
  SupportingItemInputTypeDTO,
  SupportingItemInputTypeDiscriminatorDTO,
  RequestedSupportingItemDTO,
} from './info-gathering'
import { BadRequest } from 'fejl'
import { timestampToISO } from '../../utils/grpc-util'

export function mapChecklistProtoToDTO(
  proto: Checklist,
  jobId: string
): ChecklistDTO {
  return {
    job_id: jobId,
    sections: proto
      .getSectionsList()
      .map((section) => mapSectionProtoToDTO(section)),
  }
}

function mapSectionProtoToDTO(proto: Section): SectionDTO {
  return {
    id: proto.getId(),
    name: proto.getName(),
    heading: proto.getHeading(),
    description: proto.getDescription(),
    requested_supporting_items: proto
      .getRequestedSupportingItemsList()
      .map((requestedSupportingItem) =>
        mapSupportingItemToDto(requestedSupportingItem)
      ),
  }
}

export function mapSupportingItemToDto(
  proto: RequestedSupportingItem
): RequestedSupportingItemDTO {
  return {
    id: proto.getId(),
    name: proto.getName(),
    heading: proto.getHeading(),
    short_description: proto.getShortDescription(),
    long_description: proto.getLongDescription(),
    image_url: proto.getImageUrl()?.getValue(),
    preview_url: proto.getPreviewUrl()?.getValue(),
    required: proto.getRequired(),
    completed: proto.getCompleted(),
    update_time: timestampToISO(proto.getUpdateTime()),
    input: {
      type: mapSupportingItemInputType(proto.getInput()),
    },
  }
}

function mapSupportingItemInputType(
  supportingItemInput?: SupportingItemInput
): SupportingItemInputTypeDTO {
  if (!supportingItemInput) {
    throw new BadRequest('Supporting item input type not found')
  }

  switch (supportingItemInput.getTypeCase()) {
    case SupportingItemInput.TypeCase.DOCUMENT:
      return mapSupportingItemDocumentInputType(
        supportingItemInput.getDocument()
      )
    default:
      throw new BadRequest('Unsupported input type')
  }
}

function mapSupportingItemDocumentInputType(
  documentInput?: SupportingItemInput.Document
): SupportingItemInputTypeDTO {
  if (!documentInput) {
    throw new BadRequest('Document input type not found')
  }

  return {
    discriminator: SupportingItemInputTypeDiscriminatorDTO.DOCUMENT,
    document: {
      document_type_short_id: documentInput.getDocumentTypeShortId(),
      document_ids: documentInput.getDocumentIdsList(),
    },
  }
}
